import { getFullStory, isFullStoryInstalled } from '.';

export const identifyToFullStory = (
  id: string,
  userVars: { [key: string]: any }
) => {
  if (!isFullStoryInstalled()) {
    return; // bail silently, we don't want to throw an error here
  }

  getFullStory().identify(id, userVars);
};
